export class DialogData {
    type!: number;
    width!: string;
    height!: string;
    classNameObtained!: string;
    dataInfo!: object;
    minWidth!: string;
    
}
